export const languageMap: { [langCode: string]: { name: string; nativeName: string } } = {
  aa: { name: 'Afar', nativeName: 'Afaraf' },
  ab: { name: 'Abkhaz', nativeName: 'аҧсуа' },
  ae: { name: 'Avestan', nativeName: 'avesta' },
  af: { name: 'Afrikaans', nativeName: 'Afrikaans' },
  ak: { name: 'Akan', nativeName: 'Akan' },
  am: { name: 'Amharic', nativeName: 'አማርኛ' },
  an: { name: 'Aragonese', nativeName: 'Aragonés' },
  ar: { name: 'Arabic', nativeName: 'العربية' },
  as: { name: 'Assamese', nativeName: 'অসমীয়া' },
  av: { name: 'Avaric', nativeName: 'авар мацӀ, магӀарул мацӀ' },
  ay: { name: 'Aymara', nativeName: 'aymar aru' },
  az: { name: 'Azerbaijani', nativeName: 'azərbaycan dili' },
  ba: { name: 'Bashkir', nativeName: 'башҡорт теле' },
  be: { name: 'Belarusian', nativeName: 'Беларуская' },
  bg: { name: 'Bulgarian', nativeName: 'български език' },
  bh: { name: 'Bihari', nativeName: 'भोजपुरी' },
  bi: { name: 'Bislama', nativeName: 'Bislama' },
  bm: { name: 'Bambara', nativeName: 'bamanankan' },
  bn: { name: 'Bengali', nativeName: 'বাংলা' },
  bo: { name: 'Tibetan Standard, Tibetan, Central', nativeName: 'བོད་ཡིག' },
  br: { name: 'Breton', nativeName: 'brezhoneg' },
  bs: { name: 'Bosnian', nativeName: 'bosanski jezik' },
  ca: { name: 'Catalan; Valencian', nativeName: 'Català' },
  ce: { name: 'Chechen', nativeName: 'нохчийн мотт' },
  ch: { name: 'Chamorro', nativeName: 'Chamoru' },
  co: { name: 'Corsican', nativeName: 'corsu, lingua corsa' },
  cr: { name: 'Cree', nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ' },
  cs: { name: 'Czech', nativeName: 'česky, čeština' },
  cu: {
    name: 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
    nativeName: 'ѩзыкъ словѣньскъ'
  },
  cv: { name: 'Chuvash', nativeName: 'чӑваш чӗлхи' },
  cy: { name: 'Welsh', nativeName: 'Cymraeg' },
  da: { name: 'Danish', nativeName: 'dansk' },
  de: { name: 'German', nativeName: 'Deutsch' },
  dv: { name: 'Divehi; Dhivehi; Maldivian;', nativeName: 'ދިވެހި' },
  ee: { name: 'Ewe', nativeName: 'Eʋegbe' },
  el: { name: 'Greek, Modern', nativeName: 'Ελληνικά' },
  en: { name: 'English', nativeName: 'English' },
  eo: { name: 'Esperanto', nativeName: 'Esperanto' },
  es: { name: 'Spanish; Castilian', nativeName: 'español, castellano' },
  et: { name: 'Estonian', nativeName: 'eesti, eesti keel' },
  eu: { name: 'Basque', nativeName: 'euskara, euskera' },
  fa: { name: 'Persian', nativeName: 'فارسی' },
  ff: { name: 'Fula; Fulah; Pulaar; Pular', nativeName: 'Fulfulde, Pulaar, Pular' },
  fi: { name: 'Finnish', nativeName: 'suomi, suomen kieli' },
  fj: { name: 'Fijian', nativeName: 'vosa Vakaviti' },
  fo: { name: 'Faroese', nativeName: 'føroyskt' },
  fr: { name: 'French', nativeName: 'français, langue française' },
  fy: { name: 'Western Frisian', nativeName: 'Frysk' },
  ga: { name: 'Irish', nativeName: 'Gaeilge' },
  gd: { name: 'Scottish Gaelic; Gaelic', nativeName: 'Gàidhlig' },
  gl: { name: 'Galician', nativeName: 'Galego' },
  gn: { name: 'Guaraní', nativeName: 'Avañeẽ' },
  gu: { name: 'Gujarati', nativeName: 'ગુજરાતી' },
  gv: { name: 'Manx', nativeName: 'Gaelg, Gailck' },
  ha: { name: 'Hausa', nativeName: 'Hausa, هَوُسَ' },
  he: { name: 'Hebrew (modern)', nativeName: 'עברית' },
  hi: { name: 'Hindi', nativeName: 'हिन्दी, हिंदी' },
  ho: { name: 'Hiri Motu', nativeName: 'Hiri Motu' },
  hr: { name: 'Croatian', nativeName: 'hrvatski' },
  ht: { name: 'Haitian; Haitian Creole', nativeName: 'Kreyòl ayisyen' },
  hu: { name: 'Hungarian', nativeName: 'Magyar' },
  hy: { name: 'Armenian', nativeName: 'Հայերեն' },
  hz: { name: 'Herero', nativeName: 'Otjiherero' },
  ia: { name: 'Interlingua', nativeName: 'Interlingua' },
  id: { name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  ie: { name: 'Interlingue', nativeName: 'Originally called Occidental; then Interlingue after WWII' },
  ig: { name: 'Igbo', nativeName: 'Asụsụ Igbo' },
  ii: { name: 'Nuosu', nativeName: 'ꆈꌠ꒿ Nuosuhxop' },
  ik: { name: 'Inupiaq', nativeName: 'Iñupiaq, Iñupiatun' },
  io: { name: 'Ido', nativeName: 'Ido' },
  is: { name: 'Icelandic', nativeName: 'Íslenska' },
  it: { name: 'Italian', nativeName: 'Italiano' },
  iu: { name: 'Inuktitut', nativeName: 'ᐃᓄᒃᑎᑐᑦ' },
  ja: { name: 'Japanese', nativeName: '日本語 (にほんご／にっぽんご)' },
  jv: { name: 'Javanese', nativeName: 'basa Jawa' },
  ka: { name: 'Georgian', nativeName: 'ქართული' },
  kg: { name: 'Kongo', nativeName: 'KiKongo' },
  ki: { name: 'Kikuyu, Gikuyu', nativeName: 'Gĩkũyũ' },
  kj: { name: 'Kwanyama, Kuanyama', nativeName: 'Kuanyama' },
  kk: { name: 'Kazakh', nativeName: 'Қазақ тілі' },
  kl: { name: 'Kalaallisut, Greenlandic', nativeName: 'kalaallisut, kalaallit oqaasii' },
  km: { name: 'Khmer', nativeName: 'ភាសាខ្មែរ' },
  kn: { name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  ko: { name: 'Korean', nativeName: '한국어 (韓國語), 조선말 (朝鮮語)' },
  kr: { name: 'Kanuri', nativeName: 'Kanuri' },
  ks: { name: 'Kashmiri', nativeName: 'कश्मीरी, كشميري‎' },
  ku: { name: 'Kurdish', nativeName: 'Kurdî, كوردی‎' },
  kv: { name: 'Komi', nativeName: 'коми кыв' },
  kw: { name: 'Cornish', nativeName: 'Kernewek' },
  ky: { name: 'Kirghiz, Kyrgyz', nativeName: 'кыргыз тили' },
  la: { name: 'Latin', nativeName: 'latine, lingua latina' },
  lb: { name: 'Luxembourgish, Letzeburgesch', nativeName: 'Lëtzebuergesch' },
  lg: { name: 'Luganda', nativeName: 'Luganda' },
  li: { name: 'Limburgish, Limburgan, Limburger', nativeName: 'Limburgs' },
  ln: { name: 'Lingala', nativeName: 'Lingála' },
  lo: { name: 'Lao', nativeName: 'ພາສາລາວ' },
  lt: { name: 'Lithuanian', nativeName: 'lietuvių kalba' },
  lu: { name: 'Luba-Katanga', nativeName: '' },
  lv: { name: 'Latvian', nativeName: 'latviešu valoda' },
  mg: { name: 'Malagasy', nativeName: 'Malagasy fiteny' },
  mh: { name: 'Marshallese', nativeName: 'Kajin M̧ajeļ' },
  mi: { name: 'Māori', nativeName: 'te reo Māori' },
  mk: { name: 'Macedonian', nativeName: 'македонски јазик' },
  ml: { name: 'Malayalam', nativeName: 'മലയാളം' },
  mn: { name: 'Mongolian', nativeName: 'монгол' },
  mr: { name: 'Marathi (Marāṭhī)', nativeName: 'मराठी' },
  ms: { name: 'Malay', nativeName: 'bahasa Melayu, بهاس ملايو‎' },
  mt: { name: 'Maltese', nativeName: 'Malti' },
  my: { name: 'Burmese', nativeName: 'ဗမာစာ' },
  na: { name: 'Nauru', nativeName: 'Ekakairũ Naoero' },
  nb: { name: 'Norwegian Bokmål', nativeName: 'Norsk bokmål' },
  nd: { name: 'North Ndebele', nativeName: 'isiNdebele' },
  ne: { name: 'Nepali', nativeName: 'नेपाली' },
  ng: { name: 'Ndonga', nativeName: 'Owambo' },
  nl: { name: 'Dutch', nativeName: 'Nederlands, Vlaams' },
  nn: { name: 'Norwegian Nynorsk', nativeName: 'Norsk nynorsk' },
  no: { name: 'Norwegian', nativeName: 'Norsk' },
  nr: { name: 'South Ndebele', nativeName: 'isiNdebele' },
  nv: { name: 'Navajo, Navaho', nativeName: 'Diné bizaad, Dinékʼehǰí' },
  ny: { name: 'Chichewa; Chewa; Nyanja', nativeName: 'chiCheŵa, chinyanja' },
  oc: { name: 'Occitan', nativeName: 'Occitan' },
  oj: { name: 'Ojibwe, Ojibwa', nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ' },
  om: { name: 'Oromo', nativeName: 'Afaan Oromoo' },
  or: { name: 'Oriya', nativeName: 'ଓଡ଼ିଆ' },
  os: { name: 'Ossetian, Ossetic', nativeName: 'ирон æвзаг' },
  pa: { name: 'Panjabi, Punjabi', nativeName: 'ਪੰਜਾਬੀ, پنجابی‎' },
  pi: { name: 'Pāli', nativeName: 'पाऴि' },
  pl: { name: 'Polish', nativeName: 'polski' },
  ps: { name: 'Pashto, Pushto', nativeName: 'پښتو' },
  pt: { name: 'Portuguese', nativeName: 'Português' },
  qu: { name: 'Quechua', nativeName: 'Runa Simi, Kichwa' },
  rm: { name: 'Romansh', nativeName: 'rumantsch grischun' },
  rn: { name: 'Kirundi', nativeName: 'kiRundi' },
  ro: { name: 'Romanian, Moldavian, Moldovan', nativeName: 'română' },
  ru: { name: 'Russian', nativeName: 'русский язык' },
  rw: { name: 'Kinyarwanda', nativeName: 'Ikinyarwanda' },
  sa: { name: 'Sanskrit (Saṁskṛta)', nativeName: 'संस्कृतम्' },
  sc: { name: 'Sardinian', nativeName: 'sardu' },
  sd: { name: 'Sindhi', nativeName: 'सिन्धी, سنڌي، سندھی‎' },
  se: { name: 'Northern Sami', nativeName: 'Davvisámegiella' },
  sg: { name: 'Sango', nativeName: 'yângâ tî sängö' },
  si: { name: 'Sinhala, Sinhalese', nativeName: 'සිංහල' },
  sk: { name: 'Slovak', nativeName: 'slovenčina' },
  sl: { name: 'Slovene', nativeName: 'slovenščina' },
  sm: { name: 'Samoan', nativeName: 'gagana faa Samoa' },
  sn: { name: 'Shona', nativeName: 'chiShona' },
  so: { name: 'Somali', nativeName: 'Soomaaliga, af Soomaali' },
  sq: { name: 'Albanian', nativeName: 'Shqip' },
  sr: { name: 'Serbian', nativeName: 'српски језик' },
  ss: { name: 'Swati', nativeName: 'SiSwati' },
  st: { name: 'Southern Sotho', nativeName: 'Sesotho' },
  su: { name: 'Sundanese', nativeName: 'Basa Sunda' },
  sv: { name: 'Swedish', nativeName: 'svenska' },
  sw: { name: 'Swahili', nativeName: 'Kiswahili' },
  ta: { name: 'Tamil', nativeName: 'தமிழ்' },
  te: { name: 'Telugu', nativeName: 'తెలుగు' },
  tg: { name: 'Tajik', nativeName: 'тоҷикӣ, toğikī, تاجیکی‎' },
  th: { name: 'Thai', nativeName: 'ไทย' },
  ti: { name: 'Tigrinya', nativeName: 'ትግርኛ' },
  tk: { name: 'Turkmen', nativeName: 'Türkmen, Түркмен' },
  tl: { name: 'Tagalog', nativeName: 'Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔' },
  tn: { name: 'Tswana', nativeName: 'Setswana' },
  to: { name: 'Tonga (Tonga Islands)', nativeName: 'faka Tonga' },
  tr: { name: 'Turkish', nativeName: 'Türkçe' },
  ts: { name: 'Tsonga', nativeName: 'Xitsonga' },
  tt: { name: 'Tatar', nativeName: 'татарча, tatarça, تاتارچا‎' },
  tw: { name: 'Twi', nativeName: 'Twi' },
  ty: { name: 'Tahitian', nativeName: 'Reo Tahiti' },
  ug: { name: 'Uighur, Uyghur', nativeName: 'Uyƣurqə, ئۇيغۇرچە‎' },
  uk: { name: 'Ukrainian', nativeName: 'українська' },
  ur: { name: 'Urdu', nativeName: 'اردو' },
  uz: { name: 'Uzbek', nativeName: 'zbek, Ўзбек, أۇزبېك‎' },
  ve: { name: 'Venda', nativeName: 'Tshivenḓa' },
  vi: { name: 'Vietnamese', nativeName: 'Tiếng Việt' },
  vo: { name: 'Volapük', nativeName: 'Volapük' },
  wa: { name: 'Walloon', nativeName: 'Walon' },
  wo: { name: 'Wolof', nativeName: 'Wollof' },
  xh: { name: 'Xhosa', nativeName: 'isiXhosa' },
  yi: { name: 'Yiddish', nativeName: 'ייִדיש' },
  yo: { name: 'Yoruba', nativeName: 'Yorùbá' },
  za: { name: 'Zhuang, Chuang', nativeName: 'Saɯ cueŋƅ, Saw cuengh' },
  zh: { name: 'Chinese', nativeName: '中文 (Zhōngwén), 汉语, 漢語' }
};

export const countriesMap: { [countryCode: string]: string } = {
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua And Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AN: 'Netherlands Antilles',
  AO: 'Angola',
  AQ: 'Antarctica',
  AR: 'Argentina',
  AS: 'American Samoa',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Aland Islands',
  AZ: 'Azerbaijan',
  BA: 'Bosnia And Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint Barthelemy',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivia',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CD: 'Congo, Democratic Republic',
  CF: 'Central African Republic',
  CG: 'Congo',
  CH: 'Switzerland',
  CI: 'Cote D"Ivoire',
  CK: 'Cook Islands',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CX: 'Christmas Island',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  EH: 'Western Sahara',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands (Malvinas)',
  FM: 'Micronesia, Federated States Of',
  FO: 'Faroe Islands',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GS: 'South Georgia And Sandwich Isl.',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard Island & Mcdonald Islands',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IM: 'Isle Of Man',
  IN: 'India',
  IO: 'British Indian Ocean Territory',
  IQ: 'Iraq',
  IR: 'Iran, Islamic Republic Of',
  IS: 'Iceland',
  IT: 'Italy',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KI: 'Kiribati',
  KM: 'Comoros',
  KN: 'Saint Kitts And Nevis',
  KP: 'North Korea',
  KR: 'Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Lao People"s Democratic Republic',
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libyan Arab Jamahiriya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Montenegro',
  MF: 'Saint Martin',
  MG: 'Madagascar',
  MH: 'Marshall Islands',
  MK: 'Macedonia',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolia',
  MO: 'Macao',
  MP: 'Northern Mariana Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PM: 'Saint Pierre And Miquelon',
  PN: 'Pitcairn',
  PR: 'Puerto Rico',
  PS: 'Palestinian Territory, Occupied',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'Saint Helena',
  SI: 'Slovenia',
  SJ: 'Svalbard And Jan Mayen',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'Sao Tome And Principe',
  SV: 'El Salvador',
  SY: 'Syrian Arab Republic',
  SZ: 'Swaziland',
  TC: 'Turks And Caicos Islands',
  TD: 'Chad',
  TF: 'French Southern Territories',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Turkey',
  TT: 'Trinidad And Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'United States Outlying Islands',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VA: 'Holy See (Vatican City State)',
  VC: 'Saint Vincent And Grenadines',
  VE: 'Venezuela',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WF: 'Wallis And Futuna',
  WS: 'Samoa',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
};

export type VoiceConfig = {
  voice: string;
  name: string;
  gender: string;
};
export const voices: {
  [langLocaleCode: string]: {
    language: string;
    voices: VoiceConfig[];
  };
} = {
  'pt-BR': {
    language: 'Portuguese (Brazil)',
    voices: [
      {
        voice: 'pt-BR-FranciscaNeural',
        name: 'Francisca',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-AntonioNeural',
        name: 'Antonio',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-MacerioMultilingualNeural',
        name: 'Macerio Multilingual',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-ThalitaMultilingualNeural',
        name: 'Thalita Multilingual',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-BrendaNeural',
        name: 'Brenda',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-DonatoNeural',
        name: 'Donato',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-ElzaNeural',
        name: 'Elza',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-FabioNeural',
        name: 'Fabio',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-GiovannaNeural',
        name: 'Giovanna',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-HumbertoNeural',
        name: 'Humberto',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-JulioNeural',
        name: 'Julio',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-LeilaNeural',
        name: 'Leila',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-LeticiaNeural',
        name: 'Leticia',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-ManuelaNeural',
        name: 'Manuela',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-NicolauNeural',
        name: 'Nicolau',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-ThalitaNeural',
        name: 'Thalita',
        gender: 'Female'
      },
      {
        voice: 'pt-BR-ValerioNeural',
        name: 'Valerio',
        gender: 'Male'
      },
      {
        voice: 'pt-BR-YaraNeural',
        name: 'Yara',
        gender: 'Female'
      }
    ]
  },
  'en-CA': {
    language: 'English (Canada)',
    voices: [
      {
        voice: 'en-CA-ClaraNeural',
        name: 'Clara',
        gender: 'Female'
      },
      {
        voice: 'en-CA-LiamNeural',
        name: 'Liam',
        gender: 'Male'
      }
    ]
  },
  'fr-CA': {
    language: 'French (Canada)',
    voices: [
      {
        voice: 'fr-CA-SylvieNeural',
        name: 'Sylvie',
        gender: 'Female'
      },
      {
        voice: 'fr-CA-JeanNeural',
        name: 'Jean',
        gender: 'Male'
      },
      {
        voice: 'fr-CA-AntoineNeural',
        name: 'Antoine',
        gender: 'Male'
      },
      {
        voice: 'fr-CA-ThierryNeural',
        name: 'Thierry',
        gender: 'Male'
      }
    ]
  },
  'fi-FI': {
    language: 'Finnish (Finland)',
    voices: [
      {
        voice: 'fi-FI-SelmaNeural',
        name: 'Selma',
        gender: 'Female'
      },
      {
        voice: 'fi-FI-HarriNeural',
        name: 'Harri',
        gender: 'Male'
      },
      {
        voice: 'fi-FI-NooraNeural',
        name: 'Noora',
        gender: 'Female'
      }
    ]
  },
  'fr-FR': {
    language: 'French (France)',
    voices: [
      {
        voice: 'fr-FR-DeniseNeural',
        name: 'Denise',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-HenriNeural',
        name: 'Henri',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-VivienneMultilingualNeural',
        name: 'Vivienne Multilingual',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-RemyMultilingualNeural',
        name: 'Remy Multilingual',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-LucienMultilingualNeural',
        name: 'Lucien Multilingual',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-AlainNeural',
        name: 'Alain',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-BrigitteNeural',
        name: 'Brigitte',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-CelesteNeural',
        name: 'Celeste',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-ClaudeNeural',
        name: 'Claude',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-CoralieNeural',
        name: 'Coralie',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-EloiseNeural',
        name: 'Eloise',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-JacquelineNeural',
        name: 'Jacqueline',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-JeromeNeural',
        name: 'Jerome',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-JosephineNeural',
        name: 'Josephine',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-MauriceNeural',
        name: 'Maurice',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-YvesNeural',
        name: 'Yves',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-YvetteNeural',
        name: 'Yvette',
        gender: 'Female'
      },
      {
        voice: 'fr-FR-Remy:DragonHDLatestNeural',
        name: 'Remy Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'fr-FR-Vivienne:DragonHDLatestNeural',
        name: 'Vivienne Dragon HD Latest',
        gender: 'Female'
      }
    ]
  },
  'de-AT': {
    language: 'German (Austria)',
    voices: [
      {
        voice: 'de-AT-IngridNeural',
        name: 'Ingrid',
        gender: 'Female'
      },
      {
        voice: 'de-AT-JonasNeural',
        name: 'Jonas',
        gender: 'Male'
      }
    ]
  },
  'de-CH': {
    language: 'German (Switzerland)',
    voices: [
      {
        voice: 'de-CH-LeniNeural',
        name: 'Leni',
        gender: 'Female'
      },
      {
        voice: 'de-CH-JanNeural',
        name: 'Jan',
        gender: 'Male'
      }
    ]
  },
  'de-DE': {
    language: 'German (Germany)',
    voices: [
      {
        voice: 'de-DE-KatjaNeural',
        name: 'Katja',
        gender: 'Female'
      },
      {
        voice: 'de-DE-ConradNeural',
        name: 'Conrad',
        gender: 'Male'
      },
      {
        voice: 'de-DE-SeraphinaMultilingualNeural',
        name: 'Seraphina Multilingual',
        gender: 'Female'
      },
      {
        voice: 'de-DE-FlorianMultilingualNeural',
        name: 'Florian Multilingual',
        gender: 'Male'
      },
      {
        voice: 'de-DE-AmalaNeural',
        name: 'Amala',
        gender: 'Female'
      },
      {
        voice: 'de-DE-BerndNeural',
        name: 'Bernd',
        gender: 'Male'
      },
      {
        voice: 'de-DE-ChristophNeural',
        name: 'Christoph',
        gender: 'Male'
      },
      {
        voice: 'de-DE-ElkeNeural',
        name: 'Elke',
        gender: 'Female'
      },
      {
        voice: 'de-DE-GiselaNeural',
        name: 'Gisela',
        gender: 'Female'
      },
      {
        voice: 'de-DE-KasperNeural',
        name: 'Kasper',
        gender: 'Male'
      },
      {
        voice: 'de-DE-KillianNeural',
        name: 'Killian',
        gender: 'Male'
      },
      {
        voice: 'de-DE-KlarissaNeural',
        name: 'Klarissa',
        gender: 'Female'
      },
      {
        voice: 'de-DE-KlausNeural',
        name: 'Klaus',
        gender: 'Male'
      },
      {
        voice: 'de-DE-LouisaNeural',
        name: 'Louisa',
        gender: 'Female'
      },
      {
        voice: 'de-DE-MajaNeural',
        name: 'Maja',
        gender: 'Female'
      },
      {
        voice: 'de-DE-RalfNeural',
        name: 'Ralf',
        gender: 'Male'
      },
      {
        voice: 'de-DE-TanjaNeural',
        name: 'Tanja',
        gender: 'Female'
      },
      {
        voice: 'de-DE-Florian:DragonHDLatestNeural',
        name: 'Florian Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'de-DE-Seraphina:DragonHDLatestNeural',
        name: 'Seraphina Dragon HD Latest',
        gender: 'Female'
      }
    ]
  },
  'it-IT': {
    language: 'Italian (Italy)',
    voices: [
      {
        voice: 'it-IT-ElsaNeural',
        name: 'Elsa',
        gender: 'Female'
      },
      {
        voice: 'it-IT-IsabellaNeural',
        name: 'Isabella',
        gender: 'Female'
      },
      {
        voice: 'it-IT-DiegoNeural',
        name: 'Diego',
        gender: 'Male'
      },
      {
        voice: 'it-IT-AlessioMultilingualNeural',
        name: 'Alessio Multilingual',
        gender: 'Male'
      },
      {
        voice: 'it-IT-IsabellaMultilingualNeural',
        name: 'Isabella Multilingual',
        gender: 'Female'
      },
      {
        voice: 'it-IT-GiuseppeMultilingualNeural',
        name: 'Giuseppe Multilingual',
        gender: 'Male'
      },
      {
        voice: 'it-IT-MarcelloMultilingualNeural',
        name: 'Marcello Multilingual',
        gender: 'Male'
      },
      {
        voice: 'it-IT-BenignoNeural',
        name: 'Benigno',
        gender: 'Male'
      },
      {
        voice: 'it-IT-CalimeroNeural',
        name: 'Calimero',
        gender: 'Male'
      },
      {
        voice: 'it-IT-CataldoNeural',
        name: 'Cataldo',
        gender: 'Male'
      },
      {
        voice: 'it-IT-FabiolaNeural',
        name: 'Fabiola',
        gender: 'Female'
      },
      {
        voice: 'it-IT-FiammaNeural',
        name: 'Fiamma',
        gender: 'Female'
      },
      {
        voice: 'it-IT-GianniNeural',
        name: 'Gianni',
        gender: 'Male'
      },
      {
        voice: 'it-IT-GiuseppeNeural',
        name: 'Giuseppe',
        gender: 'Male'
      },
      {
        voice: 'it-IT-ImeldaNeural',
        name: 'Imelda',
        gender: 'Female'
      },
      {
        voice: 'it-IT-IrmaNeural',
        name: 'Irma',
        gender: 'Female'
      },
      {
        voice: 'it-IT-LisandroNeural',
        name: 'Lisandro',
        gender: 'Male'
      },
      {
        voice: 'it-IT-PalmiraNeural',
        name: 'Palmira',
        gender: 'Female'
      },
      {
        voice: 'it-IT-PierinaNeural',
        name: 'Pierina',
        gender: 'Female'
      },
      {
        voice: 'it-IT-RinaldoNeural',
        name: 'Rinaldo',
        gender: 'Male'
      }
    ]
  },
  'ja-JP': {
    language: 'Japanese (Japan)',
    voices: [
      {
        voice: 'ja-JP-NanamiNeural',
        name: 'Nanami',
        gender: 'Female'
      },
      {
        voice: 'ja-JP-KeitaNeural',
        name: 'Keita',
        gender: 'Male'
      },
      {
        voice: 'ja-JP-AoiNeural',
        name: 'Aoi',
        gender: 'Female'
      },
      {
        voice: 'ja-JP-DaichiNeural',
        name: 'Daichi',
        gender: 'Male'
      },
      {
        voice: 'ja-JP-MayuNeural',
        name: 'Mayu',
        gender: 'Female'
      },
      {
        voice: 'ja-JP-NaokiNeural',
        name: 'Naoki',
        gender: 'Male'
      },
      {
        voice: 'ja-JP-ShioriNeural',
        name: 'Shiori',
        gender: 'Female'
      },
      {
        voice: 'ja-JP-MasaruMultilingualNeural',
        name: 'Masaru Multilingual',
        gender: 'Male'
      },
      {
        voice: 'ja-JP-Masaru:DragonHDLatestNeural',
        name: 'Masaru Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'ja-JP-Nanami:DragonHDLatestNeural',
        name: 'Nanami Dragon HD Latest',
        gender: 'Female'
      }
    ]
  },
  'nl-NL': {
    language: 'Dutch (Netherlands)',
    voices: [
      {
        voice: 'nl-NL-FennaNeural',
        name: 'Fenna',
        gender: 'Female'
      },
      {
        voice: 'nl-NL-MaartenNeural',
        name: 'Maarten',
        gender: 'Male'
      },
      {
        voice: 'nl-NL-ColetteNeural',
        name: 'Colette',
        gender: 'Female'
      }
    ]
  },
  'nb-NO': {
    language: 'Norwegian Bokmål (Norway)',
    voices: [
      {
        voice: 'nb-NO-PernilleNeural',
        name: 'Pernille',
        gender: 'Female'
      },
      {
        voice: 'nb-NO-FinnNeural',
        name: 'Finn',
        gender: 'Male'
      },
      {
        voice: 'nb-NO-IselinNeural',
        name: 'Iselin',
        gender: 'Female'
      }
    ]
  },
  'en-SG': {
    language: 'English (Singapore)',
    voices: [
      {
        voice: 'en-SG-LunaNeural',
        name: 'Luna',
        gender: 'Female'
      },
      {
        voice: 'en-SG-WayneNeural',
        name: 'Wayne',
        gender: 'Male'
      }
    ]
  },
  'ta-SG': {
    language: 'Tamil (Singapore)',
    voices: [
      {
        voice: 'ta-SG-VenbaNeural',
        name: 'Venba',
        gender: 'Female'
      },
      {
        voice: 'ta-SG-AnbuNeural',
        name: 'Anbu',
        gender: 'Male'
      }
    ]
  },
  'es-AR': {
    language: 'Spanish (Argentina)',
    voices: [
      {
        voice: 'es-AR-ElenaNeural',
        name: 'Elena',
        gender: 'Female'
      },
      {
        voice: 'es-AR-TomasNeural',
        name: 'Tomas',
        gender: 'Male'
      }
    ]
  },
  'es-BO': {
    language: 'Spanish (Bolivia)',
    voices: [
      {
        voice: 'es-BO-SofiaNeural',
        name: 'Sofia',
        gender: 'Female'
      },
      {
        voice: 'es-BO-MarceloNeural',
        name: 'Marcelo',
        gender: 'Male'
      }
    ]
  },
  'es-CL': {
    language: 'Spanish (Chile)',
    voices: [
      {
        voice: 'es-CL-CatalinaNeural',
        name: 'Catalina',
        gender: 'Female'
      },
      {
        voice: 'es-CL-LorenzoNeural',
        name: 'Lorenzo',
        gender: 'Male'
      }
    ]
  },
  'es-CO': {
    language: 'Spanish (Colombia)',
    voices: [
      {
        voice: 'es-CO-SalomeNeural',
        name: 'Salome',
        gender: 'Female'
      },
      {
        voice: 'es-CO-GonzaloNeural',
        name: 'Gonzalo',
        gender: 'Male'
      }
    ]
  },
  'es-CR': {
    language: 'Spanish (Costa Rica)',
    voices: [
      {
        voice: 'es-CR-MariaNeural',
        name: 'Maria',
        gender: 'Female'
      },
      {
        voice: 'es-CR-JuanNeural',
        name: 'Juan',
        gender: 'Male'
      }
    ]
  },
  'es-CU': {
    language: 'Spanish (Cuba)',
    voices: [
      {
        voice: 'es-CU-BelkysNeural',
        name: 'Belkys',
        gender: 'Female'
      },
      {
        voice: 'es-CU-ManuelNeural',
        name: 'Manuel',
        gender: 'Male'
      }
    ]
  },
  'es-DO': {
    language: 'Spanish (Dominican Republic)',
    voices: [
      {
        voice: 'es-DO-RamonaNeural',
        name: 'Ramona',
        gender: 'Female'
      },
      {
        voice: 'es-DO-EmilioNeural',
        name: 'Emilio',
        gender: 'Male'
      }
    ]
  },
  'es-EC': {
    language: 'Spanish (Ecuador)',
    voices: [
      {
        voice: 'es-EC-AndreaNeural',
        name: 'Andrea',
        gender: 'Female'
      },
      {
        voice: 'es-EC-LuisNeural',
        name: 'Luis',
        gender: 'Male'
      }
    ]
  },
  'es-ES': {
    language: 'Spanish (Spain)',
    voices: [
      {
        voice: 'es-ES-ElviraNeural',
        name: 'Elvira',
        gender: 'Female'
      },
      {
        voice: 'es-ES-AlvaroNeural',
        name: 'Alvaro',
        gender: 'Male'
      },
      {
        voice: 'es-ES-ArabellaMultilingualNeural',
        name: 'Arabella Multilingual',
        gender: 'Female'
      },
      {
        voice: 'es-ES-IsidoraMultilingualNeural',
        name: 'Isidora Multilingual',
        gender: 'Female'
      },
      {
        voice: 'es-ES-TristanMultilingualNeural',
        name: 'Tristan Multilingual',
        gender: 'Male'
      },
      {
        voice: 'es-ES-XimenaMultilingualNeural',
        name: 'Ximena Multilingual',
        gender: 'Female'
      },
      {
        voice: 'es-ES-AbrilNeural',
        name: 'Abril',
        gender: 'Female'
      },
      {
        voice: 'es-ES-ArnauNeural',
        name: 'Arnau',
        gender: 'Male'
      },
      {
        voice: 'es-ES-DarioNeural',
        name: 'Dario',
        gender: 'Male'
      },
      {
        voice: 'es-ES-EliasNeural',
        name: 'Elias',
        gender: 'Male'
      },
      {
        voice: 'es-ES-EstrellaNeural',
        name: 'Estrella',
        gender: 'Female'
      },
      {
        voice: 'es-ES-IreneNeural',
        name: 'Irene',
        gender: 'Female'
      },
      {
        voice: 'es-ES-LaiaNeural',
        name: 'Laia',
        gender: 'Female'
      },
      {
        voice: 'es-ES-LiaNeural',
        name: 'Lia',
        gender: 'Female'
      },
      {
        voice: 'es-ES-NilNeural',
        name: 'Nil',
        gender: 'Male'
      },
      {
        voice: 'es-ES-SaulNeural',
        name: 'Saul',
        gender: 'Male'
      },
      {
        voice: 'es-ES-TeoNeural',
        name: 'Teo',
        gender: 'Male'
      },
      {
        voice: 'es-ES-TrianaNeural',
        name: 'Triana',
        gender: 'Female'
      },
      {
        voice: 'es-ES-VeraNeural',
        name: 'Vera',
        gender: 'Female'
      },
      {
        voice: 'es-ES-XimenaNeural',
        name: 'Ximena',
        gender: 'Female'
      },
      {
        voice: 'es-ES-Tristan:DragonHDLatestNeural',
        name: 'Tristan Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'es-ES-Ximena:DragonHDLatestNeural',
        name: 'Ximena Dragon HD Latest',
        gender: 'Female'
      }
    ]
  },
  'es-GQ': {
    language: 'Spanish (Equatorial Guinea)',
    voices: [
      {
        voice: 'es-GQ-TeresaNeural',
        name: 'Teresa',
        gender: 'Female'
      },
      {
        voice: 'es-GQ-JavierNeural',
        name: 'Javier',
        gender: 'Male'
      }
    ]
  },
  'es-GT': {
    language: 'Spanish (Guatemala)',
    voices: [
      {
        voice: 'es-GT-MartaNeural',
        name: 'Marta',
        gender: 'Female'
      },
      {
        voice: 'es-GT-AndresNeural',
        name: 'Andres',
        gender: 'Male'
      }
    ]
  },
  'es-HN': {
    language: 'Spanish (Honduras)',
    voices: [
      {
        voice: 'es-HN-KarlaNeural',
        name: 'Karla',
        gender: 'Female'
      },
      {
        voice: 'es-HN-CarlosNeural',
        name: 'Carlos',
        gender: 'Male'
      }
    ]
  },
  'es-MX': {
    language: 'Spanish (Mexico)',
    voices: [
      {
        voice: 'es-MX-DaliaNeural',
        name: 'Dalia',
        gender: 'Female'
      },
      {
        voice: 'es-MX-JorgeNeural',
        name: 'Jorge',
        gender: 'Male'
      },
      {
        voice: 'es-MX-BeatrizNeural',
        name: 'Beatriz',
        gender: 'Female'
      },
      {
        voice: 'es-MX-CandelaNeural',
        name: 'Candela',
        gender: 'Female'
      },
      {
        voice: 'es-MX-CarlotaNeural',
        name: 'Carlota',
        gender: 'Female'
      },
      {
        voice: 'es-MX-CecilioNeural',
        name: 'Cecilio',
        gender: 'Male'
      },
      {
        voice: 'es-MX-GerardoNeural',
        name: 'Gerardo',
        gender: 'Male'
      },
      {
        voice: 'es-MX-LarissaNeural',
        name: 'Larissa',
        gender: 'Female'
      },
      {
        voice: 'es-MX-LibertoNeural',
        name: 'Liberto',
        gender: 'Male'
      },
      {
        voice: 'es-MX-LucianoNeural',
        name: 'Luciano',
        gender: 'Male'
      },
      {
        voice: 'es-MX-MarinaNeural',
        name: 'Marina',
        gender: 'Female'
      },
      {
        voice: 'es-MX-NuriaNeural',
        name: 'Nuria',
        gender: 'Female'
      },
      {
        voice: 'es-MX-PelayoNeural',
        name: 'Pelayo',
        gender: 'Male'
      },
      {
        voice: 'es-MX-RenataNeural',
        name: 'Renata',
        gender: 'Female'
      },
      {
        voice: 'es-MX-YagoNeural',
        name: 'Yago',
        gender: 'Male'
      }
    ]
  },
  'es-NI': {
    language: 'Spanish (Nicaragua)',
    voices: [
      {
        voice: 'es-NI-YolandaNeural',
        name: 'Yolanda',
        gender: 'Female'
      },
      {
        voice: 'es-NI-FedericoNeural',
        name: 'Federico',
        gender: 'Male'
      }
    ]
  },
  'es-PA': {
    language: 'Spanish (Panama)',
    voices: [
      {
        voice: 'es-PA-MargaritaNeural',
        name: 'Margarita',
        gender: 'Female'
      },
      {
        voice: 'es-PA-RobertoNeural',
        name: 'Roberto',
        gender: 'Male'
      }
    ]
  },
  'es-PE': {
    language: 'Spanish (Peru)',
    voices: [
      {
        voice: 'es-PE-CamilaNeural',
        name: 'Camila',
        gender: 'Female'
      },
      {
        voice: 'es-PE-AlexNeural',
        name: 'Alex',
        gender: 'Male'
      }
    ]
  },
  'es-PR': {
    language: 'Spanish (Puerto Rico)',
    voices: [
      {
        voice: 'es-PR-KarinaNeural',
        name: 'Karina',
        gender: 'Female'
      },
      {
        voice: 'es-PR-VictorNeural',
        name: 'Victor',
        gender: 'Male'
      }
    ]
  },
  'es-PY': {
    language: 'Spanish (Paraguay)',
    voices: [
      {
        voice: 'es-PY-TaniaNeural',
        name: 'Tania',
        gender: 'Female'
      },
      {
        voice: 'es-PY-MarioNeural',
        name: 'Mario',
        gender: 'Male'
      }
    ]
  },
  'es-SV': {
    language: 'Spanish (El Salvador)',
    voices: [
      {
        voice: 'es-SV-LorenaNeural',
        name: 'Lorena',
        gender: 'Female'
      },
      {
        voice: 'es-SV-RodrigoNeural',
        name: 'Rodrigo',
        gender: 'Male'
      }
    ]
  },
  'es-US': {
    language: 'Spanish (United States)',
    voices: [
      {
        voice: 'es-US-PalomaNeural',
        name: 'Paloma',
        gender: 'Female'
      },
      {
        voice: 'es-US-AlonsoNeural',
        name: 'Alonso',
        gender: 'Male'
      }
    ]
  },
  'es-UY': {
    language: 'Spanish (Uruguay)',
    voices: [
      {
        voice: 'es-UY-ValentinaNeural',
        name: 'Valentina',
        gender: 'Female'
      },
      {
        voice: 'es-UY-MateoNeural',
        name: 'Mateo',
        gender: 'Male'
      }
    ]
  },
  'es-VE': {
    language: 'Spanish (Venezuela)',
    voices: [
      {
        voice: 'es-VE-PaolaNeural',
        name: 'Paola',
        gender: 'Female'
      },
      {
        voice: 'es-VE-SebastianNeural',
        name: 'Sebastian',
        gender: 'Male'
      }
    ]
  },
  'en-AU': {
    language: 'English (Australia)',
    voices: [
      {
        voice: 'en-AU-NatashaNeural',
        name: 'Natasha',
        gender: 'Female'
      },
      {
        voice: 'en-AU-WilliamNeural',
        name: 'William',
        gender: 'Male'
      },
      {
        voice: 'en-AU-AnnetteNeural',
        name: 'Annette',
        gender: 'Female'
      },
      {
        voice: 'en-AU-CarlyNeural',
        name: 'Carly',
        gender: 'Female'
      },
      {
        voice: 'en-AU-DarrenNeural',
        name: 'Darren',
        gender: 'Male'
      },
      {
        voice: 'en-AU-DuncanNeural',
        name: 'Duncan',
        gender: 'Male'
      },
      {
        voice: 'en-AU-ElsieNeural',
        name: 'Elsie',
        gender: 'Female'
      },
      {
        voice: 'en-AU-FreyaNeural',
        name: 'Freya',
        gender: 'Female'
      },
      {
        voice: 'en-AU-JoanneNeural',
        name: 'Joanne',
        gender: 'Female'
      },
      {
        voice: 'en-AU-KenNeural',
        name: 'Ken',
        gender: 'Male'
      },
      {
        voice: 'en-AU-KimNeural',
        name: 'Kim',
        gender: 'Female'
      },
      {
        voice: 'en-AU-NeilNeural',
        name: 'Neil',
        gender: 'Male'
      },
      {
        voice: 'en-AU-TimNeural',
        name: 'Tim',
        gender: 'Male'
      },
      {
        voice: 'en-AU-TinaNeural',
        name: 'Tina',
        gender: 'Female'
      }
    ]
  },
  'en-GB': {
    language: 'English (United Kingdom)',
    voices: [
      {
        voice: 'en-GB-SoniaNeural',
        name: 'Sonia',
        gender: 'Female'
      },
      {
        voice: 'en-GB-RyanNeural',
        name: 'Ryan',
        gender: 'Male'
      },
      {
        voice: 'en-GB-LibbyNeural',
        name: 'Libby',
        gender: 'Female'
      },
      {
        voice: 'en-GB-AdaMultilingualNeural',
        name: 'Ada Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-GB-OllieMultilingualNeural',
        name: 'Ollie Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-GB-AbbiNeural',
        name: 'Abbi',
        gender: 'Female'
      },
      {
        voice: 'en-GB-AlfieNeural',
        name: 'Alfie',
        gender: 'Male'
      },
      {
        voice: 'en-GB-BellaNeural',
        name: 'Bella',
        gender: 'Female'
      },
      {
        voice: 'en-GB-ElliotNeural',
        name: 'Elliot',
        gender: 'Male'
      },
      {
        voice: 'en-GB-EthanNeural',
        name: 'Ethan',
        gender: 'Male'
      },
      {
        voice: 'en-GB-HollieNeural',
        name: 'Hollie',
        gender: 'Female'
      },
      {
        voice: 'en-GB-MaisieNeural',
        name: 'Maisie',
        gender: 'Female'
      },
      {
        voice: 'en-GB-NoahNeural',
        name: 'Noah',
        gender: 'Male'
      },
      {
        voice: 'en-GB-OliverNeural',
        name: 'Oliver',
        gender: 'Male'
      },
      {
        voice: 'en-GB-OliviaNeural',
        name: 'Olivia',
        gender: 'Female'
      },
      {
        voice: 'en-GB-ThomasNeural',
        name: 'Thomas',
        gender: 'Male'
      },
      {
        voice: 'en-GB-MiaNeural',
        name: 'Mia',
        gender: 'Female'
      }
    ]
  },
  'en-HK': {
    language: 'English (Hong Kong SAR)',
    voices: [
      {
        voice: 'en-HK-YanNeural',
        name: 'Yan',
        gender: 'Female'
      },
      {
        voice: 'en-HK-SamNeural',
        name: 'Sam',
        gender: 'Male'
      }
    ]
  },
  'en-IE': {
    language: 'English (Ireland)',
    voices: [
      {
        voice: 'en-IE-EmilyNeural',
        name: 'Emily',
        gender: 'Female'
      },
      {
        voice: 'en-IE-ConnorNeural',
        name: 'Connor',
        gender: 'Male'
      }
    ]
  },
  'en-US': {
    language: 'English (United States)',
    voices: [
      {
        voice: 'en-US-AvaMultilingualNeural',
        name: 'Ava Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-AndrewMultilingualNeural',
        name: 'Andrew Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-EmmaMultilingualNeural',
        name: 'Emma Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-AlloyTurboMultilingualNeural',
        name: 'Alloy Turbo Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-EchoTurboMultilingualNeural',
        name: 'Echo Turbo Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-FableTurboMultilingualNeural',
        name: 'Fable Turbo Multilingual',
        gender: 'Neutral'
      },
      {
        voice: 'en-US-OnyxTurboMultilingualNeural',
        name: 'Onyx Turbo Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-NovaTurboMultilingualNeural',
        name: 'Nova Turbo Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-ShimmerTurboMultilingualNeural',
        name: 'Shimmer Turbo Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-BrianMultilingualNeural',
        name: 'Brian Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-AvaNeural',
        name: 'Ava',
        gender: 'Female'
      },
      {
        voice: 'en-US-AndrewNeural',
        name: 'Andrew',
        gender: 'Male'
      },
      {
        voice: 'en-US-EmmaNeural',
        name: 'Emma',
        gender: 'Female'
      },
      {
        voice: 'en-US-BrianNeural',
        name: 'Brian',
        gender: 'Male'
      },
      {
        voice: 'en-US-JennyNeural',
        name: 'Jenny',
        gender: 'Female'
      },
      {
        voice: 'en-US-GuyNeural',
        name: 'Guy',
        gender: 'Male'
      },
      {
        voice: 'en-US-AriaNeural',
        name: 'Aria',
        gender: 'Female'
      },
      {
        voice: 'en-US-DavisNeural',
        name: 'Davis',
        gender: 'Male'
      },
      {
        voice: 'en-US-JaneNeural',
        name: 'Jane',
        gender: 'Female'
      },
      {
        voice: 'en-US-JasonNeural',
        name: 'Jason',
        gender: 'Male'
      },
      {
        voice: 'en-US-KaiNeural',
        name: 'Kai',
        gender: 'Male'
      },
      {
        voice: 'en-US-LunaNeural',
        name: 'Luna',
        gender: 'Female'
      },
      {
        voice: 'en-US-SaraNeural',
        name: 'Sara',
        gender: 'Female'
      },
      {
        voice: 'en-US-TonyNeural',
        name: 'Tony',
        gender: 'Male'
      },
      {
        voice: 'en-US-NancyNeural',
        name: 'Nancy',
        gender: 'Female'
      },
      {
        voice: 'en-US-CoraMultilingualNeural',
        name: 'Cora Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-ChristopherMultilingualNeural',
        name: 'Christopher Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-BrandonMultilingualNeural',
        name: 'Brandon Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-AmberNeural',
        name: 'Amber',
        gender: 'Female'
      },
      {
        voice: 'en-US-AnaNeural',
        name: 'Ana',
        gender: 'Female'
      },
      {
        voice: 'en-US-AshleyNeural',
        name: 'Ashley',
        gender: 'Female'
      },
      {
        voice: 'en-US-BrandonNeural',
        name: 'Brandon',
        gender: 'Male'
      },
      {
        voice: 'en-US-ChristopherNeural',
        name: 'Christopher',
        gender: 'Male'
      },
      {
        voice: 'en-US-CoraNeural',
        name: 'Cora',
        gender: 'Female'
      },
      {
        voice: 'en-US-ElizabethNeural',
        name: 'Elizabeth',
        gender: 'Female'
      },
      {
        voice: 'en-US-EricNeural',
        name: 'Eric',
        gender: 'Male'
      },
      {
        voice: 'en-US-JacobNeural',
        name: 'Jacob',
        gender: 'Male'
      },
      {
        voice: 'en-US-JennyMultilingualNeural',
        name: 'Jenny Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-MichelleNeural',
        name: 'Michelle',
        gender: 'Female'
      },
      {
        voice: 'en-US-MonicaNeural',
        name: 'Monica',
        gender: 'Female'
      },
      {
        voice: 'en-US-RogerNeural',
        name: 'Roger',
        gender: 'Male'
      },
      {
        voice: 'en-US-RyanMultilingualNeural',
        name: 'Ryan Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-SteffanNeural',
        name: 'Steffan',
        gender: 'Male'
      },
      {
        voice: 'en-US-AdamMultilingualNeural',
        name: 'Adam Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-AIGenerate1Neural',
        name: 'AIGenerate1',
        gender: 'Male'
      },
      {
        voice: 'en-US-AIGenerate2Neural',
        name: 'AIGenerate2',
        gender: 'Female'
      },
      {
        voice: 'en-US-AmandaMultilingualNeural',
        name: 'Amanda Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-BlueNeural',
        name: 'Blue',
        gender: 'Neutral'
      },
      {
        voice: 'en-US-DavisMultilingualNeural',
        name: 'Davis Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-DerekMultilingualNeural',
        name: 'Derek Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-DustinMultilingualNeural',
        name: 'Dustin Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-EvelynMultilingualNeural',
        name: 'Evelyn Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-LewisMultilingualNeural',
        name: 'Lewis Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-LolaMultilingualNeural',
        name: 'Lola Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-NancyMultilingualNeural',
        name: 'Nancy Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-PhoebeMultilingualNeural',
        name: 'Phoebe Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-SamuelMultilingualNeural',
        name: 'Samuel Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-SerenaMultilingualNeural',
        name: 'Serena Multilingual',
        gender: 'Female'
      },
      {
        voice: 'en-US-SteffanMultilingualNeural',
        name: 'Steffan Multilingual',
        gender: 'Male'
      },
      {
        voice: 'en-US-Adam:DragonHDLatestNeural',
        name: 'Adam Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'en-US-Alloy:DragonHDLatestNeural',
        name: 'Alloy Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'en-US-Andrew:DragonHDLatestNeural',
        name: 'Andrew Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'en-US-Andrew2:DragonHDLatestNeural',
        name: 'Andrew2 Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'en-US-Andrew3:DragonHDLatestNeural',
        name: 'Andrew3 Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'en-US-Aria:DragonHDLatestNeural',
        name: 'Aria Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Ava:DragonHDLatestNeural',
        name: 'Ava Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Ava3:DragonHDLatestNeural',
        name: 'Ava3 Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Brian:DragonHDLatestNeural',
        name: 'Brian Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'en-US-Davis:DragonHDLatestNeural',
        name: 'Davis Dragon HD Latest',
        gender: 'Male'
      },
      {
        voice: 'en-US-Emma:DragonHDLatestNeural',
        name: 'Emma Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Emma2:DragonHDLatestNeural',
        name: 'Emma2 Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Jenny:DragonHDLatestNeural',
        name: 'Jenny Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Nova:DragonHDLatestNeural',
        name: 'Nova Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Phoebe:DragonHDLatestNeural',
        name: 'Phoebe Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Serena:DragonHDLatestNeural',
        name: 'Serena Dragon HD Latest',
        gender: 'Female'
      },
      {
        voice: 'en-US-Steffan:DragonHDLatestNeural',
        name: 'Steffan Dragon HD Latest',
        gender: 'Male'
      }
    ]
  },
  'en-IN': {
    language: 'English (India)',
    voices: [
      {
        voice: 'en-IN-AaravNeural',
        name: 'Aarav',
        gender: 'Male'
      },
      {
        voice: 'en-IN-AashiNeural',
        name: 'Aashi',
        gender: 'Female'
      },
      {
        voice: 'en-IN-AartiNeural',
        name: 'Aarti',
        gender: 'Female'
      },
      {
        voice: 'en-IN-ArjunNeural',
        name: 'Arjun',
        gender: 'Male'
      },
      {
        voice: 'en-IN-AnanyaNeural',
        name: 'Ananya',
        gender: 'Female'
      },
      {
        voice: 'en-IN-KavyaNeural',
        name: 'Kavya',
        gender: 'Female'
      },
      {
        voice: 'en-IN-KunalNeural',
        name: 'Kunal',
        gender: 'Male'
      },
      {
        voice: 'en-IN-NeerjaNeural',
        name: 'Neerja',
        gender: 'Female'
      },
      {
        voice: 'en-IN-PrabhatNeural',
        name: 'Prabhat',
        gender: 'Male'
      },
      {
        voice: 'en-IN-RehaanNeural',
        name: 'Rehaan',
        gender: 'Male'
      }
    ]
  },
  'en-KE': {
    language: 'English (Kenya)',
    voices: [
      {
        voice: 'en-KE-AsiliaNeural',
        name: 'Asilia',
        gender: 'Female'
      },
      {
        voice: 'en-KE-ChilembaNeural',
        name: 'Chilemba',
        gender: 'Male'
      }
    ]
  },
  'en-NZ': {
    language: 'English (New Zealand)',
    voices: [
      {
        voice: 'en-NZ-MollyNeural',
        name: 'Molly',
        gender: 'Female'
      },
      {
        voice: 'en-NZ-MitchellNeural',
        name: 'Mitchell',
        gender: 'Male'
      }
    ]
  },
  'en-PH': {
    language: 'English (Philippines)',
    voices: [
      {
        voice: 'en-PH-RosaNeural',
        name: 'Rosa',
        gender: 'Female'
      },
      {
        voice: 'en-PH-JamesNeural',
        name: 'James',
        gender: 'Male'
      }
    ]
  },
  'af-ZA': {
    language: 'Afrikaans (South Africa)',
    voices: [
      {
        voice: 'af-ZA-AdriNeural',
        name: 'Adri',
        gender: 'Female'
      },
      {
        voice: 'af-ZA-WillemNeural',
        name: 'Willem',
        gender: 'Male'
      }
    ]
  },
  'ar-AE': {
    language: 'Arabic (United Arab Emirates)',
    voices: [
      {
        voice: 'ar-AE-FatimaNeural',
        name: 'Fatima',
        gender: 'Female'
      },
      {
        voice: 'ar-AE-HamdanNeural',
        name: 'Hamdan',
        gender: 'Male'
      }
    ]
  },
  'ar-EG': {
    language: 'Arabic (Egypt)',
    voices: [
      {
        voice: 'ar-EG-SalmaNeural',
        name: 'Salma',
        gender: 'Female'
      },
      {
        voice: 'ar-EG-ShakirNeural',
        name: 'Shakir',
        gender: 'Male'
      }
    ]
  },
  'ar-IQ': {
    language: 'Arabic (Iraq)',
    voices: [
      {
        voice: 'ar-IQ-RanaNeural',
        name: 'Rana',
        gender: 'Female'
      },
      {
        voice: 'ar-IQ-BasselNeural',
        name: 'Bassel',
        gender: 'Male'
      }
    ]
  },
  'ar-MA': {
    language: 'Arabic (Morocco)',
    voices: [
      {
        voice: 'ar-MA-MounaNeural',
        name: 'Mouna',
        gender: 'Female'
      },
      {
        voice: 'ar-MA-JamalNeural',
        name: 'Jamal',
        gender: 'Male'
      }
    ]
  },
  'ar-SA': {
    language: 'Arabic (Saudi Arabia)',
    voices: [
      {
        voice: 'ar-SA-ZariyahNeural',
        name: 'Zariyah',
        gender: 'Female'
      },
      {
        voice: 'ar-SA-HamedNeural',
        name: 'Hamed',
        gender: 'Male'
      }
    ]
  },
  'bn-BD': {
    language: 'Bangla (Bangladesh)',
    voices: [
      {
        voice: 'bn-BD-NabanitaNeural',
        name: 'Nabanita',
        gender: 'Female'
      },
      {
        voice: 'bn-BD-PradeepNeural',
        name: 'Pradeep',
        gender: 'Male'
      }
    ]
  },
  'ca-ES': {
    language: 'Catalan',
    voices: [
      {
        voice: 'ca-ES-JoanaNeural',
        name: 'Joana',
        gender: 'Female'
      },
      {
        voice: 'ca-ES-EnricNeural',
        name: 'Enric',
        gender: 'Male'
      },
      {
        voice: 'ca-ES-AlbaNeural',
        name: 'Alba',
        gender: 'Female'
      }
    ]
  },
  'cs-CZ': {
    language: 'Czech (Czechia)',
    voices: [
      {
        voice: 'cs-CZ-VlastaNeural',
        name: 'Vlasta',
        gender: 'Female'
      },
      {
        voice: 'cs-CZ-AntoninNeural',
        name: 'Antonin',
        gender: 'Male'
      }
    ]
  },
  'cy-GB': {
    language: 'Welsh (United Kingdom)',
    voices: [
      {
        voice: 'cy-GB-NiaNeural',
        name: 'Nia',
        gender: 'Female'
      },
      {
        voice: 'cy-GB-AledNeural',
        name: 'Aled',
        gender: 'Male'
      }
    ]
  },
  'da-DK': {
    language: 'Danish (Denmark)',
    voices: [
      {
        voice: 'da-DK-ChristelNeural',
        name: 'Christel',
        gender: 'Female'
      },
      {
        voice: 'da-DK-JeppeNeural',
        name: 'Jeppe',
        gender: 'Male'
      }
    ]
  },
  'fil-PH': {
    language: 'Filipino (Philippines)',
    voices: [
      {
        voice: 'fil-PH-BlessicaNeural',
        name: 'Blessica',
        gender: 'Female'
      },
      {
        voice: 'fil-PH-AngeloNeural',
        name: 'Angelo',
        gender: 'Male'
      }
    ]
  },
  'fr-BE': {
    language: 'French (Belgium)',
    voices: [
      {
        voice: 'fr-BE-CharlineNeural',
        name: 'Charline',
        gender: 'Female'
      },
      {
        voice: 'fr-BE-GerardNeural',
        name: 'Gerard',
        gender: 'Male'
      }
    ]
  },
  'fr-CH': {
    language: 'French (Switzerland)',
    voices: [
      {
        voice: 'fr-CH-ArianeNeural',
        name: 'Ariane',
        gender: 'Female'
      },
      {
        voice: 'fr-CH-FabriceNeural',
        name: 'Fabrice',
        gender: 'Male'
      }
    ]
  },
  'ga-IE': {
    language: 'Irish (Ireland)',
    voices: [
      {
        voice: 'ga-IE-OrlaNeural',
        name: 'Orla',
        gender: 'Female'
      },
      {
        voice: 'ga-IE-ColmNeural',
        name: 'Colm',
        gender: 'Male'
      }
    ]
  },
  'gl-ES': {
    language: 'Galician',
    voices: [
      {
        voice: 'gl-ES-SabelaNeural',
        name: 'Sabela',
        gender: 'Female'
      },
      {
        voice: 'gl-ES-RoiNeural',
        name: 'Roi',
        gender: 'Male'
      }
    ]
  },
  'gu-IN': {
    language: 'Gujarati (India)',
    voices: [
      {
        voice: 'gu-IN-DhwaniNeural',
        name: 'Dhwani',
        gender: 'Female'
      },
      {
        voice: 'gu-IN-NiranjanNeural',
        name: 'Niranjan',
        gender: 'Male'
      }
    ]
  },
  'he-IL': {
    language: 'Hebrew (Israel)',
    voices: [
      {
        voice: 'he-IL-HilaNeural',
        name: 'Hila',
        gender: 'Female'
      },
      {
        voice: 'he-IL-AvriNeural',
        name: 'Avri',
        gender: 'Male'
      }
    ]
  },
  'hi-IN': {
    language: 'Hindi (India)',
    voices: [
      {
        voice: 'hi-IN-AaravNeural',
        name: 'Aarav',
        gender: 'Male'
      },
      {
        voice: 'hi-IN-AnanyaNeural',
        name: 'Ananya',
        gender: 'Female'
      },
      {
        voice: 'hi-IN-AartiNeural',
        name: 'Aarti',
        gender: 'Female'
      },
      {
        voice: 'hi-IN-ArjunNeural',
        name: 'Arjun',
        gender: 'Male'
      },
      {
        voice: 'hi-IN-KavyaNeural',
        name: 'Kavya',
        gender: 'Female'
      },
      {
        voice: 'hi-IN-KunalNeural',
        name: 'Kunal',
        gender: 'Male'
      },
      {
        voice: 'hi-IN-RehaanNeural',
        name: 'Rehaan',
        gender: 'Male'
      },
      {
        voice: 'hi-IN-SwaraNeural',
        name: 'Swara',
        gender: 'Female'
      },
      {
        voice: 'hi-IN-MadhurNeural',
        name: 'Madhur',
        gender: 'Male'
      }
    ]
  },
  'id-ID': {
    language: 'Indonesian (Indonesia)',
    voices: [
      {
        voice: 'id-ID-GadisNeural',
        name: 'Gadis',
        gender: 'Female'
      },
      {
        voice: 'id-ID-ArdiNeural',
        name: 'Ardi',
        gender: 'Male'
      }
    ]
  },
  'jv-ID': {
    language: 'Javanese (Latin, Indonesia)',
    voices: [
      {
        voice: 'jv-ID-SitiNeural',
        name: 'Siti',
        gender: 'Female'
      },
      {
        voice: 'jv-ID-DimasNeural',
        name: 'Dimas',
        gender: 'Male'
      }
    ]
  },
  'kk-KZ': {
    language: 'Kazakh (Kazakhstan)',
    voices: [
      {
        voice: 'kk-KZ-AigulNeural',
        name: 'Aigul',
        gender: 'Female'
      },
      {
        voice: 'kk-KZ-DauletNeural',
        name: 'Daulet',
        gender: 'Male'
      }
    ]
  },
  'kn-IN': {
    language: 'Kannada (India)',
    voices: [
      {
        voice: 'kn-IN-SapnaNeural',
        name: 'Sapna',
        gender: 'Female'
      },
      {
        voice: 'kn-IN-GaganNeural',
        name: 'Gagan',
        gender: 'Male'
      }
    ]
  },
  'ko-KR': {
    language: 'Korean (Korea)',
    voices: [
      {
        voice: 'ko-KR-SunHiNeural',
        name: 'Sun-Hi',
        gender: 'Female'
      },
      {
        voice: 'ko-KR-InJoonNeural',
        name: 'InJoon',
        gender: 'Male'
      },
      {
        voice: 'ko-KR-HyunsuMultilingualNeural',
        name: 'Hyunsu Multilingual',
        gender: 'Male'
      },
      {
        voice: 'ko-KR-BongJinNeural',
        name: 'BongJin',
        gender: 'Male'
      },
      {
        voice: 'ko-KR-GookMinNeural',
        name: 'GookMin',
        gender: 'Male'
      },
      {
        voice: 'ko-KR-HyunsuNeural',
        name: 'Hyunsu',
        gender: 'Male'
      },
      {
        voice: 'ko-KR-JiMinNeural',
        name: 'JiMin',
        gender: 'Female'
      },
      {
        voice: 'ko-KR-SeoHyeonNeural',
        name: 'SeoHyeon',
        gender: 'Female'
      },
      {
        voice: 'ko-KR-SoonBokNeural',
        name: 'SoonBok',
        gender: 'Female'
      },
      {
        voice: 'ko-KR-YuJinNeural',
        name: 'YuJin',
        gender: 'Female'
      }
    ]
  },
  'mr-IN': {
    language: 'Marathi (India)',
    voices: [
      {
        voice: 'mr-IN-AarohiNeural',
        name: 'Aarohi',
        gender: 'Female'
      },
      {
        voice: 'mr-IN-ManoharNeural',
        name: 'Manohar',
        gender: 'Male'
      }
    ]
  },
  'ms-MY': {
    language: 'Malay (Malaysia)',
    voices: [
      {
        voice: 'ms-MY-YasminNeural',
        name: 'Yasmin',
        gender: 'Female'
      },
      {
        voice: 'ms-MY-OsmanNeural',
        name: 'Osman',
        gender: 'Male'
      }
    ]
  },
  'nl-BE': {
    language: 'Dutch (Belgium)',
    voices: [
      {
        voice: 'nl-BE-DenaNeural',
        name: 'Dena',
        gender: 'Female'
      },
      {
        voice: 'nl-BE-ArnaudNeural',
        name: 'Arnaud',
        gender: 'Male'
      }
    ]
  },
  'or-IN': {
    language: 'Odia (India)',
    voices: [
      {
        voice: 'or-IN-SubhasiniNeural',
        name: 'Subhasini',
        gender: 'Female'
      },
      {
        voice: 'or-IN-SukantNeural',
        name: 'Sukant',
        gender: 'Male'
      }
    ]
  },
  'pa-IN': {
    language: 'Punjabi (India)',
    voices: [
      {
        voice: 'pa-IN-OjasNeural',
        name: 'Ojas',
        gender: 'Male'
      },
      {
        voice: 'pa-IN-VaaniNeural',
        name: 'Vaani',
        gender: 'Female'
      }
    ]
  },
  'pl-PL': {
    language: 'Polish (Poland)',
    voices: [
      {
        voice: 'pl-PL-AgnieszkaNeural',
        name: 'Agnieszka',
        gender: 'Female'
      },
      {
        voice: 'pl-PL-MarekNeural',
        name: 'Marek',
        gender: 'Male'
      },
      {
        voice: 'pl-PL-ZofiaNeural',
        name: 'Zofia',
        gender: 'Female'
      }
    ]
  },
  'ro-RO': {
    language: 'Romanian (Romania)',
    voices: [
      {
        voice: 'ro-RO-AlinaNeural',
        name: 'Alina',
        gender: 'Female'
      },
      {
        voice: 'ro-RO-EmilNeural',
        name: 'Emil',
        gender: 'Male'
      }
    ]
  },
  'ru-RU': {
    language: 'Russian (Russia)',
    voices: [
      {
        voice: 'ru-RU-SvetlanaNeural',
        name: 'Svetlana',
        gender: 'Female'
      },
      {
        voice: 'ru-RU-DmitryNeural',
        name: 'Dmitry',
        gender: 'Male'
      },
      {
        voice: 'ru-RU-DariyaNeural',
        name: 'Dariya',
        gender: 'Female'
      }
    ]
  },
  'si-LK': {
    language: 'Sinhala (Sri Lanka)',
    voices: [
      {
        voice: 'si-LK-ThiliniNeural',
        name: 'Thilini',
        gender: 'Female'
      },
      {
        voice: 'si-LK-SameeraNeural',
        name: 'Sameera',
        gender: 'Male'
      }
    ]
  },
  'sr-RS': {
    language: 'Serbian (Cyrillic, Serbia)',
    voices: [
      {
        voice: 'sr-RS-SophieNeural',
        name: 'Sophie',
        gender: 'Female'
      },
      {
        voice: 'sr-RS-NicholasNeural',
        name: 'Nicholas',
        gender: 'Male'
      }
    ]
  },
  'ta-IN': {
    language: 'Tamil (India)',
    voices: [
      {
        voice: 'ta-IN-PallaviNeural',
        name: 'Pallavi',
        gender: 'Female'
      },
      {
        voice: 'ta-IN-ValluvarNeural',
        name: 'Valluvar',
        gender: 'Male'
      }
    ]
  },
  'ta-LK': {
    language: 'Tamil (Sri Lanka)',
    voices: [
      {
        voice: 'ta-LK-SaranyaNeural',
        name: 'Saranya',
        gender: 'Female'
      },
      {
        voice: 'ta-LK-KumarNeural',
        name: 'Kumar',
        gender: 'Male'
      }
    ]
  },
  'ta-MY': {
    language: 'Tamil (Malaysia)',
    voices: [
      {
        voice: 'ta-MY-KaniNeural',
        name: 'Kani',
        gender: 'Female'
      },
      {
        voice: 'ta-MY-SuryaNeural',
        name: 'Surya',
        gender: 'Male'
      }
    ]
  },
  'te-IN': {
    language: 'Telugu (India)',
    voices: [
      {
        voice: 'te-IN-ShrutiNeural',
        name: 'Shruti',
        gender: 'Female'
      },
      {
        voice: 'te-IN-MohanNeural',
        name: 'Mohan',
        gender: 'Male'
      }
    ]
  },
  'th-TH': {
    language: 'Thai (Thailand)',
    voices: [
      {
        voice: 'th-TH-PremwadeeNeural',
        name: 'Premwadee',
        gender: 'Female'
      },
      {
        voice: 'th-TH-NiwatNeural',
        name: 'Niwat',
        gender: 'Male'
      },
      {
        voice: 'th-TH-AcharaNeural',
        name: 'Achara',
        gender: 'Female'
      }
    ]
  },
  'tr-TR': {
    language: 'Turkish (Türkiye)',
    voices: [
      {
        voice: 'tr-TR-EmelNeural',
        name: 'Emel',
        gender: 'Female'
      },
      {
        voice: 'tr-TR-AhmetNeural',
        name: 'Ahmet',
        gender: 'Male'
      }
    ]
  },
  'uk-UA': {
    language: 'Ukrainian (Ukraine)',
    voices: [
      {
        voice: 'uk-UA-PolinaNeural',
        name: 'Polina',
        gender: 'Female'
      },
      {
        voice: 'uk-UA-OstapNeural',
        name: 'Ostap',
        gender: 'Male'
      }
    ]
  },
  'ur-IN': {
    language: 'Urdu (India)',
    voices: [
      {
        voice: 'ur-IN-GulNeural',
        name: 'Gul',
        gender: 'Female'
      },
      {
        voice: 'ur-IN-SalmanNeural',
        name: 'Salman',
        gender: 'Male'
      }
    ]
  },
  'ur-PK': {
    language: 'Urdu (Pakistan)',
    voices: [
      {
        voice: 'ur-PK-UzmaNeural',
        name: 'Uzma',
        gender: 'Female'
      },
      {
        voice: 'ur-PK-AsadNeural',
        name: 'Asad',
        gender: 'Male'
      }
    ]
  },
  'vi-VN': {
    language: 'Vietnamese (Vietnam)',
    voices: [
      {
        voice: 'vi-VN-HoaiMyNeural',
        name: 'HoaiMy',
        gender: 'Female'
      },
      {
        voice: 'vi-VN-NamMinhNeural',
        name: 'NamMinh',
        gender: 'Male'
      }
    ]
  }
};

export const availableVoiceLangages = Array.from(
  new Map(
    Object.keys(voices)
      .map(key => {
        const langCode = key.substring(0, 2);
        const lang = languageMap[langCode];

        return [langCode, lang];
      })
  )
).sort(([_valueA, labelA], [_valueB, labelB]) => labelA.name.localeCompare(labelB.name));

export const getCountriesByLanguage = (lang: string) => {
  const countries: { countryCode: string; countryName: string }[] = [];

  for (const [countryCode, _country] of Object.entries(voices)) {
    if (countryCode.startsWith(lang)) {
      const country = countriesMap[countryCode.substring(3, 5)];
      countries.push({
        countryCode,
        countryName: country
      });
    }
  }

  return countries.sort((a, b) => a.countryName.localeCompare(b.countryName));
};
